import type { Fund, FundsFilterValues } from '../funds-step.types';

export const hasAnyFundsFilter = (filters: FundsFilterValues): boolean =>
  !!filters.source.length ||
  !!filters.type.length ||
  filters.instAid !== null ||
  filters.totalAid !== null;

export const matchesFundsFilters = (
  fund: Fund,
  filters: FundsFilterValues
): boolean => {
  if (
    !!filters.source.length &&
    !filters.source.includes(String(fund.source))
  ) {
    return false;
  }

  if (!!filters.type.length && !filters.type.includes(String(fund.type))) {
    return false;
  }

  if (filters.instAid !== null && Boolean(fund.instAid) !== filters.instAid) {
    return false;
  }

  if (
    filters.totalAid !== null &&
    Boolean(fund.totalAid) !== filters.totalAid
  ) {
    return false;
  }

  return true;
};

export const filterFunds = (
  funds: Fund[],
  filters: FundsFilterValues
): Fund[] => {
  if (!hasAnyFundsFilter(filters)) {
    return funds;
  }

  return funds.filter((fund) => matchesFundsFilters(fund, filters));
};

export const removeFundsFilter = (
  filters: FundsFilterValues,
  field: keyof FundsFilterValues,
  value?: string
): FundsFilterValues => {
  if (field === 'instAid' || field === 'totalAid') {
    return { ...filters, [field]: null };
  }

  return {
    ...filters,
    [field]: filters[field].filter((entry) => entry !== value),
  };
};
